// Complete modified myapp.js (updated to import and route to RouterTest and ApiTest)
// This adds two routes: "/Routertest" for the Router Test page and "/apitest" for the API Test page.
// You can access them at http://localhost:3000/Routertest and http://localhost:3000/apitest (assuming your dev server runs on port 3000)

import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import Login from './pages/Login';
import Home from './pages/Home';
import Enquiry from './pages/Enquiry';
import Details from './pages/Details';
import ThankYou from './pages/ThankYou';
import DThankYou from './pages/D_ThankYou';
import Logout from './pages/Logout';
import RouterTest from './pages/RouterTest'; // Import the Router Test page
import ApiTest from './pages/ApiTest'; // NEW: Import the API Test page
import { PaymentProvider } from './contexts/PaymentContext';
import { AppProvider } from './contexts/AppContext';
import PrivateRoute from './components/PrivateRoute';

// Wrapper component to provide navigate to AppProvider
function AppWithRouter() {
  const navigate = useNavigate();
  
  return (
    <AppProvider navigate={navigate}>
      <PaymentProvider>
        <Routes>
          {/* 改咗 Login route 成 path="/Login/:guid"，大寫 L + path param */}
          <Route path="/Login/:guid" element={<Login />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/thankyou" element={<ThankYou />} />
          <Route path="/d_thankyou" element={<DThankYou />} /> 
          <Route path="/" element={<PrivateRoute><Home /></PrivateRoute>} />
          <Route path="/details" element={<PrivateRoute><Details /></PrivateRoute>} />            
          <Route path="/enquiry" element={<PrivateRoute><Enquiry /></PrivateRoute>} />
          
          {/* Router Test route - not protected, so accessible without login */}
          <Route path="/Routertest" element={<RouterTest />} />
          
          {/* NEW: API Test route - not protected, so accessible without login */}
          <Route path="/apitest" element={<ApiTest />} />
        </Routes>
      </PaymentProvider>
    </AppProvider>
  );
}

function App() {
  return (
    <Router>
      <AppWithRouter />
    </Router>
  );
}

export default App;